import styled from "styled-components";

export const Container = styled.div`
    display: inline-flex;
    align-items: center;
    background: ${props => props.theme.colors.neutralBg};
    border-radius: 999px;
    height: 40px;
`;

export const ContainerCircle = styled.div`
    height: 40px;
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;
    cursor: pointer;

    span{
        font-size: 22px;
        line-height: 1;
        color: ${props => props.theme.colors.ink};
        transition: color 0.2s;
    }

    &:hover span {
        color: ${props => props.theme.colors.primary};
    }
`;

export const CountIncrement = styled.span`
    min-width: 40px;
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    color: ${props => props.theme.colors.ink};
`;
